export default function LinkedInIcon({ socialIconClass }) {
  return (
    <svg className={socialIconClass} viewBox='0 0 57.54 57.54'>
      <path
        fill='#fff'
        d='M28.77,0C12.88,0,0,12.88,0,28.77s12.88,28.77,28.77,28.77,28.77-12.88,28.77-28.77S44.66,0,28.77,0Zm-9.52,44.76h-6.48V23h6.48v21.76Zm-3.28-24.96c-2.16,0-3.84-1.76-3.84-3.92s1.68-3.92,3.84-3.92,3.92,1.76,3.92,3.92-1.76,3.92-3.92,3.92Zm28.8,13.6v11.36h-6.4v-11.76c-.08-2.48-1.76-4.4-4.24-4.4s-4.56,1.92-4.64,4.4v11.76h-6.4V23h6.4v3.04c1.36-2,3.6-3.28,6.16-3.28h1.76c4.08,0,7.36,3.36,7.36,7.36v3.28Z'
      />
    </svg>
  );
}
